import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

// import static assets
import browser from '../assets/img/browser.svg';

const isVideoFile = (file) => {
  // Check if the URL contains mimeType parameter indicating WebM
  if (file.includes('mimeType=')) {
    const mimeTypeMatch = file.match(/mimeType=([^&]+)/);
    if (mimeTypeMatch) {
      const mimeType = decodeURIComponent(mimeTypeMatch[1]);
      return mimeType.includes('webm') || mimeType.includes('video/webm');
    }
  }
  // Fallback to filename check for direct file URLs
  return file.includes('.webm');
};

function Carousel({ screenshots }) {
  // CAROUSEL SECTION
  // useState for Carousel
  const [currentSlide, setCurrentSlide] = useState(0);

  // only set slideLength if screenshots exist
  const slideLength =
    typeof screenshots !== 'undefined' ? screenshots.length : 0;

  let chevCounter = currentSlide + 1;

  let prevChev = chevCounter > 1 ? chevCounter - 1 : '..';
  let nextChev = chevCounter < screenshots.length ? chevCounter + 1 : '..';

  const displayFile = isVideoFile(screenshots[currentSlide]) ? (
    <VideoFormat screenshots={screenshots} currentSlide={currentSlide} />
  ) : (
    <PicFormat
      key={screenshots[currentSlide]}
      screenshots={screenshots}
      currentSlide={currentSlide}
    />
  );

  return (
    <>
      <div className="projPage__carouselCont__carousel">
        <div className="projPage__carouselCont__carousel__content">
          {displayFile}
        </div>
      </div>

      <span
        className="projPage__spanIcons projPage__carouselCont__chev projPage__spanIcons projPage__carouselCont__chev1"
        onClick={() =>
          setCurrentSlide((prev) =>
            currentSlide > 0 ? prev - 1 : slideLength - 1
          )
        }
      >
        {prevChev < 10 ? '0' : ''}
        {prevChev}
      </span>
      <span
        className="projPage__spanIcons projPage__carouselCont__chev projPage__spanIcons projPage__carouselCont__chev2"
        onClick={() =>
          setCurrentSlide((prev) =>
            currentSlide + 1 < slideLength ? prev + 1 : 0
          )
        }
      >
        {nextChev < 10 ? '0' : ''}
        {nextChev}
      </span>
    </>
  );
}

const playBubbleAnimation = (ref) =>
  gsap.from(ref.current, {
    autoAlpha: 0,
    scale: 0.8,
    ease: 'back',
    duration: 1,
    clearProps: 'all',
  });

function VideoFormat({ screenshots, currentSlide }) {
  const videoPath = screenshots[currentSlide];
  const videoRef = useRef(null);
  useEffect(() => {
    playBubbleAnimation(videoRef);
  }, [currentSlide]);
  return (
    <video
      ref={videoRef}
      key={currentSlide}
      className="projPage__carouselCont__carousel__content__screenshot"
      style={{
        maxWidth: '886px',
        display: 'block',
        margin: '0 auto',
        borderRadius: '10px',
      }} // overwrites some screenshot styles so that the 'box-shadow' is aligned properly
      playsInline
      autoPlay
      muted
      loop
    >
      <source src={videoPath} type="video/webm" />
    </video>
  );
}

function PicFormat({ screenshots, currentSlide }) {
  const [screenshotLoaded, setScreenshotLoaded] = useState(false);
  const screenshotRef = useRef(null);
  useEffect(() => {
    playBubbleAnimation(screenshotRef);
  }, [currentSlide]);

  const lookAheadScreenshot = screenshots[currentSlide + 1];

  return (
    <div ref={screenshotRef}>
      {screenshotLoaded && (
        <img
          className="projPage__carouselCont__carousel__content__browserSVG"
          src={browser}
          alt="web browser vector art"
        />
      )}
      <img
        className="projPage__carouselCont__carousel__content__screenshot"
        src={screenshots[currentSlide]}
        alt="project screenshot"
        onLoad={() => setScreenshotLoaded(true)}
      />
      {!!lookAheadScreenshot && (
        <img
          className="projPage__carouselCont__carousel__content__screenshot_two"
          src={lookAheadScreenshot}
          alt="another project screenshot"
        />
      )}
    </div>
  );
}

export default Carousel;
